import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet-async';
import {
    ConfigProvider,
    theme,
    Input,
    Select,
    DatePicker,
    Button,
    Upload,
    Avatar,
    Checkbox,
    Space, Tooltip
} from 'antd';
import {
    ChevronDown,
    ChevronRight,
    Search,
    Calendar,
    X,
    Plus,
    UploadCloud,
    RefreshCw,
    AlertTriangle,
    CircleHelp
} from 'lucide-react';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import Layout from '../../Layout'; // Giữ nguyên layout của bạn
import { Link } from "react-router-dom";
import { mixformatCurrency } from 'services/mixin';

const { TextArea } = Input;
const { Dragger } = Upload;

export default function AddExpense() {
    const [isDarkMode, setIsDarkMode] = useState(false);

    // 1. Quản lý trạng thái Đóng/Mở (Collapse)
    const [expandedSections, setExpandedSections] = useState({
        general: true,
        detail: true,
        products: true,
        recept: true,
        related: true,
    });

    const toggleSection = (key) => {
        setExpandedSections(prev => ({ ...prev, [key]: !prev[key] }));
    };

    // 2. Data và State cho detail
    const [details, setDetails] = useState([
        { id: 1, name: 'Thu phí chuẩn đoán hình', quantity: 1, price: 1000000, taxPercent: 10, taxCost: 1000000, total: 11000000 },
    ]);

    const handleAddDetail = () => {
        setDetails([...details, { id: Date.now(), name: '', quantity: 0, price: 0, taxPercent: 0, taxCost: 0, total: 0 }]);
    };
    const handleRemoveDetail = (id) => {
        setDetails(details.filter(p => p.id !== id));
    };

    // 3. Data và State cho hóa đơn
    const [recepts, setRecept] = useState([
        { id: 1, code: '4517127', date: '2026-08-25' },
    ]);

    const handleAddRecept = () => {
        setRecept([...recepts, { id: Date.now(), code: '', date: '' }]);
    };
    const handleRemoveRecept = (id) => {
        setRecept(recepts.filter(p => p.id !== id));
    };

    // Theme Config (Màu chủ đạo #3e91ab)
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab',
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
            controlHeight: 40,
        },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const SectionHeader = ({ title, sectionKey }) => (
        <div
            onClick={() => toggleSection(sectionKey)}
            className="flex items-center gap-2 text-[#3e91ab] font-medium text-sm mb-4 mt-8 first:mt-0 cursor-pointer hover:opacity-80 transition-opacity select-none"
        >
            {expandedSections[sectionKey] ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            <span>{title}</span>
        </div>
    );

    // --- Data và State cho Đối tượng liên quan ---
    const relatedObjectOptions = [
        { value: 'co_hoi', label: 'Cơ hội' },
        { value: 'khach_hang', label: 'Khách hàng' },
        { value: 'doi_tac', label: 'Đối tác' },
    ];

    const [relatedObjects, setRelatedObjects] = useState([
        { id: 1, type: null },
        { id: 2, type: null }
    ]);

    const handleAddRelated = () => {
        setRelatedObjects([...relatedObjects, { id: Date.now(), type: null }]);
    };

    const handleRemoveRelated = (id) => {
        setRelatedObjects(relatedObjects.filter(item => item.id !== id));
    };

    return (
        <Layout>
            <Helmet>
                            <title> Tạo mới phiếu chi | Khothi</title>
                        </Helmet>
            <ConfigProvider theme={antdThemeConfig}>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* Header cố định */}
                    {/* <div className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 md:px-6 py-4 sticky top-[64px] z-10 shadow-sm">
                        <div className="flex items-center gap-2 text-sm mb-2">
                            <Link to="/purchase-order" className="flex items-center gap-2">
                                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white">
                                    <LeftOutlined className="text-[10px]" />
                                </div>
                            </Link>
                            <Link to="/purchase-order" className="text-gray-600 dark:text-gray-400 hover:text-[#3e91ab]">
                                Đơn hàng mua
                            </Link>
                            <span><RightOutlined className="w-3 h-3 text-gray-400" /></span>
                            <span className="text-gray-800 dark:text-gray-200 font-medium">Thêm mới đơn hàng mua</span>
                        </div>
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                            Thêm mới ĐHM
                        </h2>
                    </div> */}
                    <div className="border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">
                        <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                            <div className="flex sm:items-center gap-4 text-sm items-start">
                                <Link to="/expense" className="flex items-center gap-2">
                                    <LeftOutlined className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white" />
                                </Link>
                                {/* <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">Thông tin chung</span> */}
                                <span className="pb-1 font-medium">Tạo mới phiếu chi</span>
                            </div>
                        </div>
                    </div>

                    {/* Nội dung form */}
                    <div className="w-full mx-auto rounded-lg shadow-sm p-4 md:p-8 mt-6 dark:bg-gray-800 bg-white border dark:border-gray-700">

                        {/* --- 1. THÔNG TIN CHUNG --- */}
                        <SectionHeader title="Thông tin chung" sectionKey="general" />
                        {expandedSections.general && (
                            <div className="w-full lg:w-[50%] flex flex-col gap-4 animate-in slide-in-from-top-2 mb-6">
                                {/* Hàng 1 */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Mã phiếu chi<span className="text-red-500">*</span></label>
                                        <Input defaultValue="PC_2026_0299" suffix={<RefreshCw size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />} />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Ngày chi <span className="text-red-500">*</span></label>
                                        <DatePicker className="w-full" format="DD/MM/YYYY" placeholder="23/08/2026" suffixIcon={<Calendar size={16} className="text-gray-400" />} />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Ngày hạch toán <span className="text-red-500">*</span></label>
                                        <DatePicker className="w-full" format="DD/MM/YYYY" placeholder="23/08/2026" suffixIcon={<Calendar size={16} className="text-gray-400" />} />
                                    </div>
                                </div>

                                {/* Các hàng Select dọc */}
                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Nội dung chi<span className="text-red-500">*</span></label>
                                    <Input placeholder="Nội dung chi" value='Mua máy oxy' />
                                </div>
                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Lý do chi <span className="text-red-500">*</span></label>
                                    <Select defaultValue="1" className="w-full" options={[{ value: '1', label: 'Chi tạm ứng' }]} />
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Tài khoản chi</label>
                                    <Select
                                        defaultValue="1"
                                        className="w-full"
                                        options={[
                                            { value: '1', label: '(hientt) Ngân hàng MB Bank', subLabel: 'abc' }
                                        ]}
                                        optionRender={(option) => (
                                            <div className="leading-tight py-0.5">
                                                <div className="text-sm font-medium text-gray-800">{option.data.label}</div>
                                                <div className="text-[11px] text-gray-400">{option.data.subLabel}</div>
                                            </div>
                                        )}
                                    />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-[150px_1fr] gap-1">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Đối tượng chi <span className="text-red-500">*</span></label>
                                        <Select
                                            defaultValue="1"
                                            className="w-full"
                                            popupMatchSelectWidth={false}
                                            options={[
                                                { value: '1', label: 'Chi trên một khách hàng' },
                                                { value: '2', label: 'Chi trên một hợp đồng bán' },
                                                { value: '3', label: 'Chi trên một đơn hàng bán' },
                                                { value: '4', label: 'Chi trực tiếp một nhà cung cấp' },
                                                { value: '5', label: 'Chi nhiều đơn hàng mua của một nhà cung cấp' },
                                                { value: '6', label: 'Chi nhiều hợp đồng mua của một nhà cung cấp' },
                                                { value: '7', label: 'Chi trên một hợp đồng mua' },
                                                { value: '8', label: 'Chi trên một đơn hàng mua' },
                                                { value: '9', label: 'Chi tạm ứng' },
                                                { value: '10', label: 'Chi khác' },
                                            ]}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Khách hàng <span className="text-red-500">*</span></label>
                                        <Select defaultValue="1" className="w-full"
                                            options={[
                                                { value: '1', label: 'KHCN01 - Võ Tuấn Huấn' },
                                            ]} />
                                    </div>
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Người nhận tiền</label>
                                    <Input placeholder="Người nhận tiền" value='TNHH Hoàng Thùy' />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-[150px_1fr] gap-2">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Số tài khoản nhận tiền</label>
                                        <Input placeholder="Số tài khoản nhận tiền" value='0128283' />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Ngân hàng nhận tiền</label>
                                        <Select defaultValue="1" className="w-full"
                                            options={[
                                                { value: '1', label: 'KHCN01 - Võ Tuấn Huấn' },
                                            ]} />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-[150px_1fr] gap-1">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 flex items-center gap-1.5">
                                            <span>Hoạch toán nội bộ </span>
                                            <Tooltip title="a">
                                                <CircleHelp size={12} className="text-orange-400 cursor-pointer" />
                                            </Tooltip> </label>
                                        <Select
                                            defaultValue="2"
                                            className="w-full"
                                            popupMatchSelectWidth={false}
                                            options={[
                                                { value: '1', label: 'Hạch toán cho dự án' },
                                                { value: '2', label: 'Hạch toán cho công việc' },
                                                { value: '3', label: 'Hạch toán cho chiến dịch marketing' },
                                                { value: '4', label: 'Hạch toán cho chiến dịch tuyển dụng' },
                                            ]}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Công việc <span className="text-red-500">*</span></label>
                                        <Select defaultValue="1" className="w-full"
                                            options={[
                                                { value: '1', label: 'KHCN01 - Võ Tuấn Huấn' },
                                            ]} />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* --- 2. Chi tiết tin --- */}
                        <div className="flex justify-between items-center mt-8 mb-4">
                            <div
                                onClick={() => toggleSection('detail')}
                                className="flex items-center gap-2 text-[#3e91ab] font-medium text-sm cursor-pointer hover:opacity-80 transition-opacity select-none"
                            >
                                {expandedSections.detail ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                                <span>Chi tiết tin</span>
                            </div>
                        </div>

                        {expandedSections.detail && (
                            <div className="flex justify-between items-center mt-8 mb-4">
                                <div className="mt-2">
                                    <Checkbox className="text-gray-600 dark:text-gray-300">Bao gồm thuế</Checkbox>
                                </div>

                                {/* Nút VND */}
                                <div className="flex items-center text-xs border dark:border-gray-600 rounded">
                                    <span className="px-3 py-1.5 border-r dark:border-gray-600 text-gray-600 dark:text-gray-300">VND</span>
                                    <span className="px-2 py-1.5 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"><X size={14} className="text-gray-400" /></span>
                                </div>
                            </div>
                        )}

                        {expandedSections.detail && (
                            <div className="animate-in slide-in-from-top-2 mb-6">
                                <div className="overflow-x-auto pb-4">
                                    <div className="min-w-[900px]">
                                        {/* Header Row */}
                                        <div className="grid grid-cols-[3fr_1fr_1.5fr_1fr_1fr_1.5fr_auto] gap-2 mb-2 text-[11px] font-medium text-gray-500 dark:text-gray-400 px-1 items-end">
                                            {/* <span className="text-center">STT</span> */}
                                            <span>Diễn giải <span className="text-red-500">*</span></span>
                                            <span>Số lượng <span className="text-red-500">*</span></span>
                                            <span>Số tiền <span className="text-red-500">*</span></span>
                                            <span>Thuế (%)</span>
                                            <span>Tiền thuế</span>
                                            <span>Tổng tiền <span className="text-red-500">*</span></span>
                                            <span className="w-6"></span>
                                        </div>

                                        {/* Product Rows */}
                                        {details.map((item, index) => (
                                            <div key={item.id} className="grid grid grid-cols-[3fr_1fr_1.5fr_1fr_1fr_1.5fr_auto] gap-2 mb-3 items-center">
                                                {/* <div className="text-center bg-gray-50 dark:bg-gray-700/50 border dark:border-gray-600 rounded h-10 flex items-center justify-center text-gray-500">{index + 1}</div> */}

                                                <Input
                                                    value={item.name}
                                                    placeholder='Diễn giải'
                                                />
                                                <Input value={item.quantity} />
                                                <Input value={mixformatCurrency(item.price)} className={`text-right`} />
                                                <Input value={item.taxPercent} className={`text-right`} />
                                                <Input value={mixformatCurrency(item.taxCost)} className={`text-right`} />
                                                <Input value={mixformatCurrency(item.total)} className={`text-right bg-gray-50 dark:bg-gray-700/50`} readOnly={index !== 0} />
                                                <X size={18} className="text-gray-400 cursor-pointer hover:text-red-500 ml-1" onClick={() => handleRemoveDetail(item.id)} />
                                            </div>
                                        ))}
                                    </div>
                                </div>



                                {/* Tổng cộng (Nằm bên phải) */}
                                <div className="flex justify-between mt-4 items-center">
                                    <button onClick={handleAddDetail} className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mb-6">
                                        <Plus size={14} />
                                    </button>
                                    <Input defaultValue="1,000,000" className="w-[200px] text-right bg-gray-50 dark:bg-gray-700/50" readOnly />

                                </div>
                            </div>
                        )}

                        {/* --- 3. Hóa đơn --- */}
                        <SectionHeader title=" Hóa đơn" sectionKey="recept" />
                        {expandedSections.recept && (
                            <div className="animate-in slide-in-from-top-2 mb-6 w-full lg:w-1/2">
                                <div className='overflow-x-auto'>
                                    <div className='max-lg:min-w-[400px]'>
                                        <div className="grid grid-cols-[1fr_1fr_auto] gap-2 mb-2 text-[11px] font-medium text-gray-500 dark:text-gray-400 px-1 items-end">
                                            {/* <span className="text-center">STT</span> */}
                                            <span>Số hóa đơn <span className="text-red-500">*</span></span>
                                            <span>Ngày xuất <span className="text-red-500">*</span></span>
                                            <span className="w-6"></span>
                                        </div>

                                        {recepts.map(item => (
                                            <div key={item.id} className="grid grid grid-cols-[1fr_1fr_auto] gap-2 mb-3 items-center">
                                                <Input
                                                    value={item.code}
                                                    placeholder='Số hóa đơn'
                                                />
                                                <DatePicker
                                                    value={item.date ? dayjs(item.date) : null}
                                                    format="DD/MM/YYYY"
                                                    className="w-full"
                                                />
                                                <X size={18} className="text-gray-400 cursor-pointer hover:text-red-500 ml-1" onClick={() => handleRemoveRecept(item.id)} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <button onClick={handleAddRecept} className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mb-6">
                                    <Plus size={14} />
                                </button>

                                <div className='mb-4'>
                                    <label className="text-xs text-gray-500 mb-1 block">Ghi chú</label>
                                    <Input placeholder="Nhập ghi chú" />
                                </div>

                                <Dragger className={`bg-transparent`} style={{ padding: '20px', border: `1px dashed ${isDarkMode ? '#4b5563' : '#d1d5db'}` }}>
                                    {/* Thêm flex-col cho mobile và sm:flex-row cho màn hình to hơn */}
                                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                                        <div className="w-10 h-10 rounded-full bg-[#3e91ab]/10 flex items-center justify-center shrink-0">
                                            <UploadCloud size={20} className="text-[#3e91ab]" />
                                        </div>
                                        <div className="text-center sm:text-left">
                                            <p className="text-gray-600 dark:text-gray-300 text-sm mb-2">
                                                Kéo thả file vào đây để tải lên hoặc
                                            </p>
                                            {/* Thêm flex-wrap để chống tràn nút */}
                                            <div className="flex flex-wrap justify-center sm:justify-start gap-2">
                                                <Button type="primary" size="small" style={{ backgroundColor: '#3e91ab' }}>
                                                    <span className='text-sm'> CHỌN TỪ MÁY</span>
                                                </Button>
                                                <Button size="small" icon={<UploadCloud size={14} />}>
                                                    <span className='text-sm'>  CHỌN TỪ CLOUD</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Dragger>
                            </div>
                        )}

                        {/* --- 4. ĐỐI TƯỢNG LIÊN QUAN --- */}
                        <SectionHeader title="Đối tượng liên quan" sectionKey="related" />
                        {expandedSections.related && (
                            <div className="animate-in slide-in-from-top-2 mb-6 max-w-2xl">
                                {relatedObjects.map((item) => (
                                    <div key={item.id} className="flex items-center gap-3 mb-3">
                                        <Select
                                            placeholder="Đối tượng liên quan"
                                            className="w-full"
                                            options={relatedObjectOptions}
                                            value={item.type}
                                            onChange={(val) => {
                                                setRelatedObjects(relatedObjects.map(obj => obj.id === item.id ? { ...obj, type: val } : obj))
                                            }}
                                        />
                                        <X
                                            size={20}
                                            className="text-gray-400 cursor-pointer hover:text-red-500 shrink-0"
                                            onClick={() => handleRemoveRelated(item.id)}
                                        />
                                    </div>
                                ))}

                                <button
                                    onClick={handleAddRelated}
                                    className="flex items-center justify-center w-8 h-8 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mt-2"
                                >
                                    <Plus size={16} />
                                </button>
                            </div>
                        )}

                        {/* --- FOOTER BUTTONS --- */}
                        <div className="flex gap-3 pt-6 border-t dark:border-gray-700">
                            <Button type="primary" size="large" style={{ backgroundColor: '#3e91ab', fontWeight: 500 }}>
                                CẬP NHẬT
                            </Button>
                            <Button size="large" className="font-medium">
                                HỦY BỎ
                            </Button>
                        </div>
                    </div>
                </div>
            </ConfigProvider>
        </Layout>
    );
}